module.exports = __WEBPACK_EXTERNAL_MODULE_79__;


//////////////////
// WEBPACK FOOTER
// external "element-ui/lib/notification"
// module id = 79
// module chunks = 0 1